/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { Locale } from '@/types/i18n';

export const LITTLE_PROMO_CONFIG = {
  SKU_ID: '879255',
  PRODUCT_ID: '18303',
  UNIQUE_ID: 3232424687,
  BRAND_ID: 'JZSR',
  PROMOTION_PRICE: '$8.00',
  MINIMUM_STH_SUBTOTAL: 75,
  SUPPORTED_LOCALES: ['en-US'] as Locale[],
  productDealIdsClaimIdsList: 'promo103100012',
  productlevelsubTotalAmount: '8.00',
} as const;
